export default __webpack_public_path__ + "static/media/Spectral-ExtraBold.c7c1712e.woff2";